import React from 'react';
import { BarChart } from '@mui/x-charts';
import { ProposalByLocation } from '../../../dashboard/ProposalsMetricsDashboard';

interface Props {
  dataset: ProposalByLocation[];
}

export const TotalMarkupByLocation = ({ dataset }: Props) => {
  return (
    <BarChart
      height={500}
      dataset={dataset}
      series={[{ label: 'Markup', dataKey: 'markup' }]}
      xAxis={[{ scaleType: 'band', dataKey: 'locationName', label: 'Location' }]}
    />
  );
};
